
import { Component, VModel } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import { visibility } from '@/types/observation'

@Component({
    mixins: [ObservationMixin],
    inheritAttrs: false,
})
export default class VisibilityFilter extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() filter!: Array<string>

    get observationVisibility() {
        return visibility.map((visib) => {
            return {
                text: this.$t(`observation_enums['observation.visibility.${visib}']`),
                value: visib,
            }
        })
    }
}
